import { Row, Col } from "react-bootstrap";
import CollectiveMembers from "components/Collective/CollectiveMembers";
import UntMembers from "components/Collective/UntMembers";
import CollectiveAdd from "components/Collective/CollectiveAdd";
import CollectiveCreate from "components/Collective/CollectiveCreate";
import AddCollectiveMember from "components/Collective/AddCollectiveMember";

export default function TFamily(props) {
  return (
    <>
      {props.consumer && !props.collective ? (
        <Row>
          <Col md="12" lg="4">
            <CollectiveAdd {...props} />
          </Col>
        </Row>
      ) : null}
      {!props.collective ? (
        <Row>
          <Col md="12" lg="4">
            <CollectiveCreate {...props} />
          </Col>
        </Row>
      ) : null}

      {props.collective && props.collective.members.length ? (
        <Row>
          <Col md="12" lg="8">
            <CollectiveMembers
              collective={props.collective}
              showAlert={props.showAlert}
              notify={props.notify}
              refreshCollective={props.refreshCollective}
            ></CollectiveMembers>
          </Col>
          <Col md="6" lg="4">
            <UntMembers
              collective={props.collective}
              refreshCollective={props.refreshCollective}
            ></UntMembers>
          </Col>
          {props.collective.members.length < 5 ? (
            <Col md="4" lg="3">
              <AddCollectiveMember {...props} />
            </Col>
          ) : null}
        </Row>
      ) : null}
    </>
  );
}
